import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    const dialog = document.getElementById('attach-result-dialog')
    if (dialog) {
      dialog.showModal()
    }
  }

  close() {
    const dialog = document.getElementById('attach-result-dialog')
    if (dialog) {
      dialog.close()
    }
  }
}
